<script setup>
// Barra de carpetas de Grupos (Victor 2026-06-05 · P2 "chips").
// Fila horizontal bajo las pestañas de la sucursal Personal, visible solo en la
// pestaña "Grupos". Cada chip es una carpeta creada por el usuario (Oficial,
// Contabilidad, …) y filtra la lista a los grupos asignados a esa carpeta.
// "Todos" muestra todos los grupos · el engranaje abre el gestor de carpetas.
// Estilo M1.B: chip activa en dorado, resto sutil. Solo Tailwind.
defineProps({
  folders: {
    type: Array,
    default: () => [],
  },
  activeId: {
    type: String,
    default: null,
  },
  counts: {
    type: Object,
    default: () => ({}),
  },
  totalCount: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['select', 'manage']);
</script>

<template>
  <div class="flex gap-2 items-center px-3 pt-2 pb-1 overflow-x-auto scroll-smooth">
    <button
      type="button"
      class="flex gap-1.5 items-center px-3 py-1.5 text-[11px] font-semibold whitespace-nowrap rounded-full border transition-colors"
      :class="activeId === null
        ? 'text-[#241c08] bg-[#c9a35a] border-transparent'
        : 'text-n-slate-11 bg-white/[.04] border-n-weak hover:text-n-slate-12'"
      @click="emit('select', null)"
    >
      Todos
      <span class="text-[9px] opacity-70">{{ totalCount }}</span>
    </button>

    <button
      v-for="folder in folders"
      :key="folder.id"
      type="button"
      class="flex gap-1.5 items-center px-3 py-1.5 text-[11px] font-semibold whitespace-nowrap rounded-full border transition-colors"
      :class="activeId === folder.id
        ? 'text-[#241c08] bg-[#c9a35a] border-transparent'
        : 'text-n-slate-11 bg-white/[.04] border-n-weak hover:text-n-slate-12'"
      @click="emit('select', folder.id)"
    >
      <span class="truncate max-w-[120px]">{{ folder.name }}</span>
      <span class="text-[9px] opacity-70">{{ counts[folder.id] || 0 }}</span>
    </button>

    <button
      type="button"
      class="flex gap-1 items-center px-3 py-1.5 text-[11px] font-semibold whitespace-nowrap rounded-full border border-dashed border-[#c9a35a]/40 text-[#e7cf9a] hover:bg-white/[.03]"
      @click="emit('manage')"
    >
      <span class="text-[12px] leading-none">⚙</span>
      Carpetas
    </button>
  </div>
</template>
